export const css = (col) => new CSS(col);
export class CSS {
    constructor(col) {
        this.value = col;
    }
    get mode() {
        return "css";
    }
    copy() {
        return new CSS(this.value);
    }
    deref() {
        return this.value;
    }
}
